/** Classic worker source: fetch uploaded index.html and compare head data-etag. */
export const deployCheckWorkerSource = `
const PATTERN = /data-etag=["']([^"']+)["']/i;
self.onmessage = async (event) => {
  const data = event.data || {};
  if (data.type !== 'check') return;
  try {
    const response = await fetch(data.indexUrl, {
      cache: 'no-store',
      credentials: 'same-origin',
    });
    if (!response.ok) return;
    const html = await response.text();
    const match = PATTERN.exec(html);
    const uploadedEtag = match && match[1] ? match[1].trim() : '';
    if (uploadedEtag && uploadedEtag !== data.etag) {
      self.postMessage({
        type: 'outdated',
        uploadedEtag,
      });
    }
  } catch (_error) {
    // Network errors are ignored; the next interval retries.
  }
};
`;
